var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"20","cy":"20","r":"16","fill":"none","opacity":".2","stroke":"currentColor","strokeWidth":"4","key":0}),React.createElement("circle",{"cx":"20","cy":"20","r":"16","fill":"none","stroke":"currentColor","strokeWidth":"4","strokeDasharray":"8 100","key":1})]);
}

Spinner.defaultProps = {"viewBox":"0 0 40 40"};

module.exports = Spinner;

Spinner.default = Spinner;
